<template>
  <div>
    <d-card-header class="border-bottom flex-header">
      <h6 class="m-0">Lista spraw egzekucyjnych</h6>
      <d-button
        v-if="!isListView"
        theme="secondary"
        @click.prevent="hideForms">
        <i class="material-icons">keyboard_backspace</i> Wróć do listy
      </d-button>
      <d-button
        v-if="isListView"
        @click.prevent="showNewExecutionForm = true"
        theme="success">
        <i class="material-icons">add</i> Dodaj Sprawę
      </d-button>
      <d-button
        v-if="showNewExecutionForm"
        @click.prevent="addNewExecution"
        theme="success"
        :class="{ isLoading: submitting_new_execution }">
        <i class="material-icons">save</i> Zapisz Sprawę
      </d-button>
    </d-card-header>
    <execution-new
      v-if="showNewExecutionForm"
      :guarantors="guarantors"
      :client="client">
    </execution-new>
    <execution-edit
      v-else-if="showExecutionForm"
      :guarantors="guarantors"
      :client="client"
      :case-id="caseID">
    </execution-edit>
    <executions-list v-else></executions-list>
  </div>
</template>

<script>
import Vue from 'vue';
import ExecutionsList from './ExecutionsList';
import ExecutionNew from './ExecutionNew';
import ExecutionEdit from './ExecutionEdit';
import { mapActions } from 'vuex';

export default {
  name: 'ExecutionView',
  props: {
    guarantors: {
      default: () => [],
      type: Array
    },
    client: {
      default: () => {},
      type: Object
    }
  },
  components: {
    ExecutionsList,
    ExecutionEdit,
    ExecutionNew
  },
  computed: {
    isListView() {
      return !this.showNewExecutionForm && !this.showExecutionForm
    }
  },
  data () {
    return {
      caseID: null,
      showExecutionForm: false,
      showNewExecutionForm: false,
      submitting_new_execution: false
    }
  },
  mounted () {
    this.$bus.$on('execution-edit', this.executionEdit);
    this.$bus.$on('execution-added', this.executionAdded);
    this.$bus.$on('execution-failed', () => {
      this.submitting_new_execution = false;
    }) ;

    this.getAllBailiffs();
    this.getAllApplications();
  },
  methods: {
    ...mapActions([
      'getAllBailiffs',
      'getAllApplications'
    ]),
    hideForms () {
      Vue.set(this, 'showNewExecutionForm', false);
      Vue.set(this, 'showExecutionForm', false);
    },
    addNewExecution () {
      this.submitting_new_execution = true;
      this.$bus.$emit('new-execution-save')
    },
    executionEdit (execution_id) {
      this.hideForms();
      Vue.set(this, 'showExecutionForm', true);
      this.caseID = parseInt(execution_id, 10);
    },
    executionAdded (execution_id) {
      Vue.set(this, 'submitting_new_execution', false);
      if (execution_id !== 0) {
        this.executionEdit(execution_id);
      }
    }
  },
  beforeDestroy () {
    const {client_id, schedule_id} = this.$route.params;
    // clears case_id if tab was changed
    if (this.$route.name === 'contract-edit') {
      this.$router.push({name: 'contract-edit', params: {client_id: client_id, schedule_id: schedule_id}})
    }
    this.$bus.$off('execution-edit', this.executionEdit);
    this.$bus.$off('execution-added', this.executionAdded);
    this.$bus.$off('execution-failed');
  }
}
</script>
